export default {
  // 该部分为了获取websocket的相关方法。会发现此处跟mutations 里的写法是类似的，但是，想使用return，需要将相关数据写在getters里面。
  STAFF_UPDATE(state) {
    return state.websock
  },
  STAFF_IS_CONNECT(state) {
    return state.isConnect
  }
}